import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable */
const Button = ({
  disabled, label, caret, onClick, type, mb, size, loading, specialClass, id,
}) => (
  <button
    id={id}
    type="button"
    className={`btn__${type} btn-${size || 'medium'} mb_${mb} ${specialClass}`}
    disabled={disabled}
    onClick={() => onClick()}
  >
    {loading ? (
      <span className="btn__loader" />
    ) : (
      <>
        <span>{label}</span>
        {caret && (
          <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.753179 0.238737C1.08227 -0.079579 1.61004 -0.079579 1.93913 0.238737L6.24682 4.4054C6.58439 4.73192 6.58439 5.26808 6.24682 5.5946L1.93913 9.76126C1.61004 10.0796 1.08227 10.0796 0.753179 9.76126C0.415607 9.43474 0.415607 8.89859 0.753179 8.57207L4.44615 5L0.753179 1.42793C0.415607 1.10141 0.415607 0.565257 0.753179 0.238737Z" />
          </svg>
        )}
      </>
    )}
  </button>
);

Button.defaultProps = {
  disabled: false,
  caret: false,
  mb: '',
  size: '',
  loading: false,
  specialClass: '',
  id: '',
};

Button.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  caret: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  mb: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.bool,
  specialClass: PropTypes.string,
  id: PropTypes.string,
};

export default Button;
